<template>
  <div
    id="box"
    :style="[
      $vuetify.breakpoint.xs
        ? { 'border-radius': '5px 5px 5px 5px' }
        : { 'border-radius': '5px 0 0 5px' },
    ]"
  >
    <div id="search-bar">
      <input
        id="search"
        v-model="search"
        @keydown.enter="compose()"
        placeholder="Compose by email"
      />
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <b-icon-info-circle
            color="white"
            font-scale="1.1"
            v-bind="attrs"
            v-on="on"
          ></b-icon-info-circle>
        </template>
        <span>
          Teachers' emails are usually of the form &lt;first name&gt;@aawaaz.co
          <br />Press Enter after entering email
        </span>
      </v-tooltip>
    </div>
    <div id="chats-list">
      <div
        @click="open(chat)"
        tabindex="0"
        @keydown.enter="open(chat)"
        class="chat"
        v-for="chat in chats"
        :key="chat.id"
      >
        <img
          class="dp"
          width="40"
          height="40"
          style="object-fit: cover"
          :src="
            chat.userData[
              chat.members.find((item) => item != userProfile.email)
            ].profilePicUrl
          "
        />
        <div class="chat-deets">
          <span style="font-size: 11pt">
            <b>{{
              chat.userData[
                chat.members.find((item) => item != userProfile.email)
              ].name
            }}</b>
          </span>
          <div style="display: flex; justify-content: space-between">
            <span
              class="mt-n1"
              style="font-size: 11pt"
              :style="[
                !chat.recipientRead && chat.lastSender != userProfile.email
                  ? { 'font-weight': 'bold' }
                  : null,
              ]"
              >{{
                chat.lastSender
                  ? chat.lastSender == userProfile.email
                    ? "You: "
                    : ""
                  : ""
              }}
              {{ chat.lastMessage ? chat.lastMessage : "" | trimLength }}</span
            >

            <!-- <span style="font-size:9pt;">{{ chat.chatUpdated | fromNow }}</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig");
import { mapState } from "vuex";
import moment from "moment";
import { debounce } from "lodash";

export default {
  data() {
    return {
      chats: [],
      search: "",
      last: null,
      subscribe: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "promise"]),
  },
  created: async function () {
    this.debouncedScroll = debounce(this.getMoreChats, 100);
    await this.promise;
    const chatsQuery = fb.db
      .collection("chats")
      .where("members", "array-contains", this.userProfile.email)
      .orderBy("chatUpdated", "desc");
    chatsQuery
      .limit(12)
      .get()
      .then((qs) => {
        this.last = qs.docs[qs.docs.length - 1];
        qs.forEach((doc) => {
          const id = doc.id;
          this.chats.push({ ...doc.data(), id });
        });
        this.chats.splice(0, 1);
      });
    this.subscribe = chatsQuery.limit(1).onSnapshot((querySnapshot) => {
      querySnapshot.docChanges().forEach((change) => {
        const id = change.doc.id;
        const data = change.doc.data();
        if (change.type === "modified" || change.type === "added") {
          this.chats = this.chats.filter((element) => element.id != id);
          this.chats.unshift({ ...data, id });
        }
      });
    });
  },
  mounted: function () {
    const chatsList = document.getElementById("chats-list");
    chatsList.addEventListener("scroll", () => {
      this.debouncedScroll();
    });
  },
  beforeDestroy() {
    this.subscribe();
  },
  methods: {
    getMoreChats() {
      const c = document.getElementById("chats-list");
      if (c.scrollTop == c.scrollHeight - c.clientHeight) {
        fb.db
          .collection("chats")
          .where("members", "array-contains", this.userProfile.email)
          .orderBy("chatUpdated", "desc")
          .startAfter(this.last)
          .limit(6)
          .get()
          .then((qs) => {
            if (!qs.empty) {
              this.last = qs.docs[qs.docs.length - 1];
              qs.forEach((doc) => {
                const id = doc.id;
                this.chats.push({ ...doc.data(), id });
              });
            }
          });
      }
    },
    open(chat) {
      this.$emit("open", chat);
      if (chat.lastSender != this.userProfile.email) {
        fb.db.collection("chats").doc(chat.id).update({ recipientRead: true });
      }
    },
    compose() {
      if (!this.search) {
        return;
      }
      const searchEmail = this.search;
      this.search = "";
      fb.db
        .collection("chats")
        .where("members", "in", [
          [this.userProfile.email, searchEmail],
          [searchEmail, this.userProfile.email],
        ])
        .get()
        .then((qs) => {
          if (qs.empty) {
            fb.db
              .collection("users")
              .where("email", "==", searchEmail)
              .get()
              .then((qs) => {
                if (qs.empty) {
                  this.makeToast("err", "Cannot find matching user");
                } else {
                  qs.forEach((doc) => {
                    if (doc.data().email == this.userProfile.email) {
                      this.makeToast(
                        "err",
                        "You cannot send messages to yourself. Stop trying to break stuff."
                      );
                      return;
                    }
                    const userData = {};
                    userData[this.userProfile.email] = {
                      name: this.userProfile.name,
                      profilePicUrl: this.userProfile.profilePicUrl,
                    };
                    userData[doc.data().email] = {
                      name: doc.data().name,
                      profilePicUrl: doc.data().profilePicUrl,
                    };
                    fb.db
                      .collection("chats")
                      .add({
                        chatUpdated: Date.now(),
                        members: [this.userProfile.email, doc.data().email],
                        userData: userData,
                      })
                      .then((docRef) => {
                        docRef.get().then((doc) => {
                          const id = doc.id;
                          this.$emit("open", {
                            ...doc.data(),
                            id,
                          });
                        });
                      });
                  });
                }
              });
          } else {
            qs.forEach((doc) => {
              const id = doc.id;
              this.$emit("open", { ...doc.data(), id });
            });
          }
        });
    },
    makeToast(type, msg) {
      switch (type) {
        case "err":
          var variant = "danger";
          var title = "Error";
          break;
        case "suc":
          var variant = "success";
          var title = "Success";
          break;
        case "war":
          var variant = "warning";
          var title = "Check Logs";
      }
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
  },
  filters: {
    fromNow(v) {
      return moment(v).fromNow();
    },
    trimLength(v) {
      if (v.length > 15) {
        return v.slice(0, 15) + "...";
      } else {
        return v;
      }
    },
  },
};
</script>

<style scoped>
#box {
  height: 40rem;
  background: rgba(0, 0, 0, 0.8);
  width: 15rem;
  display: flex;
  flex-direction: column;
  /* justify-content: flex-end; */
  align-items: center;
  color: white;
}
#search-bar {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 15rem;
  height: 2.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
#chats-list {
  overflow: scroll;
  width: 15rem;
  height: 37.5rem;
}
#search {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 12rem;
  height: 1.25rem;
  background: #fefefe;
  border-radius: 10px;
  font-size: 10pt;
  padding: 0px 10px;
}

.chat {
  display: flex;
  flex-direction: row;
  /* text-align: right; */
  width: 15rem;
  padding: 7px 15px;
}
.dp {
  border-radius: 50px;
}
.chat-deets {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 8px;
}

.chat:hover {
  background-color: #757575;
  cursor: pointer;
}

.chat-w-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>